export default "__VITE_ASSET__Z7pCBPISBeXeUjAujdQJ6w__"